import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_FAC004_Request,
  IAPI_FAC004_Response,
} from "../../../type/apiType";
import {
  IAPI_FAC029_Request,
  IAPI_FAC029_Response,
} from "../../../type/apiType";
import {
  IAPI_FAC022_Request,
  IAPI_FAC022_Response,
} from "../../../type/apiType";

// 施設情報　新規登録（通常）表示
// API仕様書_施設
const httpIAPI_FAC004 = async (
  param: IAPI_FAC004_Request
): Promise<IAPI_FAC004_Response> => {
  let res = await http.post(ApiUrl.API_FAC004, {
    ...param,
  });
  return res.data;
};

// 施設等新設届・申請施設更新API
// API仕様書_施設
const httpIAPI_FAC029 = async (
  param: IAPI_FAC029_Request
): Promise<IAPI_FAC029_Response> => {
  let res = await http.post(ApiUrl.API_FAC029, {
    ...param,
  });
  return res.data;
};

// 施設引継ぎコード参照
// API仕様書_施設
const httpIAPI_FAC022 = async (
  param: IAPI_FAC022_Request
): Promise<IAPI_FAC022_Response> => {
  let res = await http.post(ApiUrl.API_FAC022, {
    ...param,
  });
  return res.data;
};

export { httpIAPI_FAC004, httpIAPI_FAC029, httpIAPI_FAC022 };
